export default __webpack_public_path__ + "static/media/login-bg-24.8ac5879a.jpg";